import { makeStyles } from 'tss-react/mui';

interface Props {
  iconOnly?: boolean;
  isOnDark?: boolean;
}

const useStyles = makeStyles<Props>({ name: 'Button' })(
  ({ fontWeights, brandColors, typography: { pxToRem } }, { iconOnly }) => ({
    button: {
      fontSize: pxToRem(16),
      fontWeight: fontWeights.medium,
      lineHeight: pxToRem(24),
      letterSpacing: pxToRem(-0.32),
      paddingLeft: pxToRem(24),
      paddingRight: pxToRem(24),
      borderRadius: pxToRem(800),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      width: 'fit-content',
      border: 'none',
    },
    Lg: {
      gap: pxToRem(18),
      padding: `${pxToRem(24)} ${pxToRem(24)}`,
    },
    Md: {
      gap: pxToRem(18),
      padding: `${pxToRem(18)} ${pxToRem(iconOnly ? 18 : 24)}`,
    },
    Sm: {
      gap: pxToRem(8),
      padding: `${pxToRem(8)} ${pxToRem(iconOnly ? 8 : 16)}`,
    },
    Xs: {
      gap: pxToRem(8),
      padding: `${pxToRem(4)} ${pxToRem(iconOnly ? 4 : 12)}`,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    iconLeft: {
      flexDirection: 'row',
    },
    iconRight: {
      flexDirection: 'row-reverse',
    },
    Primary: {
      '&.light': {
        backgroundColor: brandColors.primaryMain,
        color: brandColors.white,
        '&:hover': {
          backgroundColor: brandColors.mediumBlue,
        },
        '&:focus': {
          backgroundColor: brandColors.mediumBlue,
        },
      },
      '&.dark': {
        backgroundColor: brandColors.white,
        color: brandColors.primaryMain,
        '&:hover': {
          backgroundColor: brandColors.tintsHeroBlue80,
          color: brandColors.primaryMain,
        },
        '&:focus': {
          backgroundColor: brandColors.tintsHeroBlue80,
          color: brandColors.primaryMain,
        },
      },
    },
    Secondary: {
      '&.light': {
        backgroundColor: 'transparent',
        color: brandColors.primaryMain,
        '&:hover': {
          backgroundColor: brandColors.interactiveHeroBlueSubtle,
          color: brandColors.mediumBlue,
        },
        '&:focus': {
          backgroundColor: brandColors.interactiveHeroBlueSubtle,
          color: brandColors.mediumBlue,
        },
      },
      '&.dark': {
        backgroundColor: 'transparent',
        color: brandColors.white,
        '&:hover': {
          backgroundColor: brandColors.foregroundInverseSubtle,
          color: brandColors.white,
        },
        '&:focus': {
          backgroundColor: brandColors.foregroundInverseSubtle,
          color: brandColors.white,
        },
      },
    },
    Tertiary: {
      '&.light': {
        backgroundColor: 'transparent',
        color: brandColors.primaryMain,
        '&:hover': {
          backgroundColor: brandColors.interactiveHeroBlueSubtle,
          color: brandColors.mediumBlue,
        },
        '&:focus': {
          backgroundColor: brandColors.interactiveHeroBlueSubtle,
          color: brandColors.mediumBlue,
        },
      },
      '&.dark': {
        backgroundColor: 'transparent',
        color: brandColors.white,
        '&:hover': {
          backgroundColor: brandColors.foregroundInverseSubtle,
          color: brandColors.white,
        },
        '&:focus': {
          backgroundColor: brandColors.foregroundInverseSubtle,
          color: brandColors.white,
        },
      },
    },
    border: {
      borderWidth: pxToRem(1),
      borderStyle: 'solid',

      '&.light': {
        borderColor: brandColors.primaryMain,
      },
      '&.dark': {
        borderColor: brandColors.white,
      },
    },
    disabled: {
      opacity: 0.3,
      pointerEvents: 'none',
    },
  })
);

export default useStyles;
